// extracted by mini-css-extract-plugin
export var reviewCard = "TrustPilot-module--reviewCard--2d635";